import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import ElementPlus from 'element-plus'
import './styles/elCustom.scss'

const app = createApp(App)
app.use(store)
store.dispatch('loadTimeInfo')
app.use(router)
app.use(CoreuiVue)
app.use(ElementPlus)
app.provide('icons', icons)
app.component('CIcon', CIcon)

app.mount('#app')
console.info('version: ' + process.env.VUE_APP_VERSION)
